<template>
  <div id="header">
    <div class="color-line"></div>
    <div id="logo" class="light-version">
        <span>
          <a :href="logoLink" target="_blank">
            <img v-bind:src="ImgLogo" alt="logo" style="max-height: 100%">
          </a>
        </span>
    </div>
    <nav role="navigation">
      <div class="header-link hide-menu"><i class="fa fa-bars"></i></div>
      <div class="small-logo">
        <span>
          <a :href="logoLink" target="_blank">
            <img  v-bind:src="ImgLogo" alt="logo" style="max-height: 100%">
          </a>
        </span>
      </div>
      <div class="mobile-menu">
        <button type="button" class="navbar-toggle mobile-menu-toggle" data-toggle="collapse" data-target="#mobile-collapse">
          <i class="fa fa-chevron-down"></i>
        </button>
        <div class="collapse mobile-navbar" id="mobile-collapse">
          <ul class="nav navbar-nav">
            <li class="dropdown" v-if="$user.isFreeTrial()">
              <button v-on:click="register" class="btn m-t btn-info">
                Free Account Signup
              </button>
            </li>
            <li>
              <a class="" v-on:click="this.$auth.logout()">Logout</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="navbar-right">
        <ul class="nav navbar-nav no-borders">
          <li class="dropdown" v-if="$user.isFreeTrial()">
            <button v-on:click="register" class="btn m-t btn-info">
              Free Account Signup
            </button>
          </li>
          <notifications-navigation></notifications-navigation>
          <li class="dropdown">
            <a v-on:click="logout" title="Log out" href="#">
              <i class="pe-7s-power "></i>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import NotificationsNavigation from '../notification/NotificationsNavigation'
export default {
  name: 'TopNavigationCo',
  components: {NotificationsNavigation},
  methods: {
    register: function () {
      this.$auth.logout({
        makeRequest: true,
        redirect: '/user/register',
        success () {
          this.$salesMachine.clearUser()
        },
        error () {
        }
      })
    },
    logout: function () {
      this.$auth.logout({
        makeRequest: true,
        redirect: '/login',
        success () {
          this.$salesMachine.clearUser()
        },
        error () {
        }
      })
    }
  },
  mounted () {
    $('.hide-menu').click(function (event) {
      event.preventDefault()
      if ($(window).width() < 769) {
        $('body').toggleClass('show-sidebar')
      } else {
        $('body').toggleClass('hide-sidebar')
      }
    })

    $('#navigation').slimScroll({
      height: '100%',
      opacity: 0.3,
      size: 0,
      wheelStep: 10
    })
  },
  beforeMount () {
    this.ImgLogo = process.env.API_URL + this.$auth.user().profile.logo
    if (typeof this.$auth.user().profile === 'undefined') {
      this.logoLink = process.env.WEBSITE_URL
    } else {
      this.logoLink = this.$auth.user().profile.id === 2 ? this.$auth.user().profile.logo_link
        : process.env.WEBSITE_URL + this.$auth.user().profile.logo_link
    }
  },
  data () {
    return {
      ImgLogo: null,
      logoLink: null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/topNavigation/TopNavigationCo.vue